import moment from 'moment';

export const breakdownOptions = [
  // { value: 'type', label: 'Type' },
  { value: 'group', label: 'Mother Group' },
  { value: 'subgroup', label: 'Sub-Group' },
  { value: 'line_item', label: 'Line Item' },
  { value: 'sub_line_item', label: 'Sub-Line Item' },
  { value: 'accounts', label: 'Account' },
];

export const frequencyOptions = [
  { value: 'month', label: 'Monthly' },
  { value: 'quarter', label: 'Quarterly' },
  { value: 'year', label: 'Yearly' },
];

export const defaultForm = {
  date_from: moment().format('YYYY-MM-DD'),
  date_to: moment().format('YYYY-MM-DD'),
  frequency: 'month',
  breakdown: ['group', 'subgroup', 'line_item', 'sub_line_item', 'accounts'],
};
